define('core/polyfills/Object',[
	'global!Object',
], function(
	Object
) {
	'use strict';

	(function(location) {
		// http://tosbourn.com/a-fix-for-window-location-origin-in-internet-explorer/
		if (! location.origin) {
			location.origin = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port: '');
		}
	}(window.location));

	/**
	 * Extend the Object prototype with some useful helper functions
	 */

	// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
	if (! Object.keys) {
		Object.keys = (function() {
			var hasOwnProperty = Object.prototype.hasOwnProperty,
				hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
				dontEnums = [
					'toString',
					'toLocaleString',
					'valueOf',
					'hasOwnProperty',
					'isPrototypeOf',
					'propertyIsEnumerable',
					'constructor'
				],
				dontEnumsLength = dontEnums.length
			;

			return function(obj) {
				if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
					throw new TypeError('Object.keys called on non-object');
				}

				var result = [], prop, i;

				for (prop in obj) {
					if (hasOwnProperty.call(obj, prop)) {
						result.push(prop);
					}
				}

				if (hasDontEnumBug) {
					for (i = 0; i < dontEnumsLength; i++) {
						if (hasOwnProperty.call(obj, dontEnums[i])) {
							result.push(dontEnums[i]);
						}
					}
				}
				return result;
			};
		}());
	}



	/**
	 * @license addEventListener polyfill 1.0 / Eirik Backer / MIT Licence
	 * https://gist.github.com/2864711/946225eb3822c203e8d6218095d888aac5e1748e
	 *
	 * http://qiita.com/sounisi5011/items/a8fc80e075e4f767b79a#11
	 */
	(function (window, document, listeners_prop_name) {
		if ((!window.addEventListener || !window.removeEventListener) && window.attachEvent && window.detachEvent) {
			/**
			 * @param {*} value
			 * @return {boolean}
			 */
			var is_callable = function (value) {
				return typeof value === 'function';
			};
			/**
			 * @param {!Window|HTMLDocument|Node} self
			 * @param {EventListener|function(!Event):(boolean|undefined)} listener
			 * @return {!function(Event)|undefined}
			 */
			var listener_get = function (self, listener) {
				var listeners = listener[listeners_prop_name];
				if (listeners) {
					var lis;
					var i = listeners.length;
					while (i--) {
						lis = listeners[i];
						if (lis[0] === self) {
							return lis[1];
						}
					}
				}
			};
			/**
			 * @param {!Window|HTMLDocument|Node} self
			 * @param {EventListener|function(!Event):(boolean|undefined)} listener
			 * @param {!function(Event)} callback
			 * @return {!function(Event)}
			 */
			var listener_set = function (self, listener, callback) {
				var listeners = listener[listeners_prop_name] || (listener[listeners_prop_name] = []);
				return listener_get(self, listener) || (listeners[listeners.length] = [self, callback], callback);
			};
			/**
			 * @param {string} methodName
			 */
			var docHijack = function (methodName) {
				var old = document[methodName];
				document[methodName] = function (v) {
					return addListen(old(v));
				};
			};
			/**
			 * @this {!Window|HTMLDocument|Node}
			 * @param {string} type
			 * @param {EventListener|function(!Event):(boolean|undefined)} listener
			 * @param {boolean=} useCapture
			 */
			var addEvent = function (type, listener, useCapture) {
				if (is_callable(listener)) {
					var self = this;
					self.attachEvent(
						'on' + type,
						listener_set(self, listener, function (e) {
							e = e || window.event;
							e.preventDefault = e.preventDefault || function () { e.returnValue = false; };
							e.stopPropagation = e.stopPropagation || function () { e.cancelBubble = true; };
							e.target = e.target || e.srcElement || document.documentElement;
							e.currentTarget = e.currentTarget || self;
							e.timeStamp = e.timeStamp || (new Date()).getTime();
							listener.call(self, e);
						})
					);
				}
			};
			/**
			 * @this {!Window|HTMLDocument|Node}
			 * @param {string} type
			 * @param {EventListener|function(!Event):(boolean|undefined)} listener
			 * @param {boolean=} useCapture
			 */
			var removeEvent = function (type, listener, useCapture) {
				if (is_callable(listener)) {
					var self = this;
					var lis = listener_get(self, listener);
					if (lis) {
						self.detachEvent('on' + type, lis);
					}
				}
			};
			/**
			 * @param {!Node|NodeList|Array} obj
			 * @return {!Node|NodeList|Array}
			 */
			var addListen = function (obj) {
				var i = obj.length;
				if (i) {
					while (i--) {
						obj[i].addEventListener = addEvent;
						obj[i].removeEventListener = removeEvent;
					}
				} else {
					obj.addEventListener = addEvent;
					obj.removeEventListener = removeEvent;
				}
				return obj;
			};

			addListen([document, window]);
			if ('Element' in window) {
				/**
				 * IE8
				 */
				var element = window.Element;
				element.prototype.addEventListener = addEvent;
				element.prototype.removeEventListener = removeEvent;
			} else {
				/**
				 * IE < 8
				 */
				//Make sure we also init at domReady
				document.attachEvent('onreadystatechange', function () { addListen(document.all); });
				docHijack('getElementsByTagName');
				docHijack('getElementById');
				docHijack('createElement');
				addListen(document.all);
			}
		}
	})(window, document, 'x-ms-event-listeners');



	// If this polyfill won't work, try this one: https://github.com/jonathantneal/Polyfills-for-IE8/blob/master/getComputedStyle.js
	// http://stackoverflow.com/a/21797294
	if (! window.getComputedStyle) {
		window.getComputedStyle = function(el, pseudo) {
			this.el = el;
			this.getPropertyValue = function(prop) {
				var re = /(\-([a-z]){1})/g;
				if (prop == 'float') prop = 'styleFloat';
				if (re.test(prop)) {
					prop = prop.replace(re, function () {
						return arguments[2].toUpperCase();
					});
				}
				return el.currentStyle[prop] ? el.currentStyle[prop] : null;
			};
			return this;
		};
	}





	// https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setTimeout#Polyfill
	/*\
	|*|
	|*|  Polyfill which enables the passage of arbitrary arguments to the
	|*|  callback functions of JavaScript timers (HTML5 standard syntax).
	|*|
	|*|  https://developer.mozilla.org/en-US/docs/DOM/window.setInterval
	|*|
	|*|  Syntax:
	|*|  var timeoutID = window.setTimeout(func, delay, [param1, param2, ...]);
	|*|  var timeoutID = window.setTimeout(code, delay);
	|*|  var intervalID = window.setInterval(func, delay[, param1, param2, ...]);
	|*|  var intervalID = window.setInterval(code, delay);
	|*|
	\*/
	(function() {
		setTimeout(function(arg1) {
			if (arg1 === 'test') {
				// feature test is passed, no need for polyfill
				return;
			}
			var __nativeST__ = window.setTimeout;
			window.setTimeout = function(vCallback, nDelay) {
				var aArgs = Array.prototype.slice.call(arguments, 2);
				return __nativeST__(vCallback instanceof Function ? function() {
					vCallback.apply(null, aArgs);
				} : vCallback, nDelay);
			};
		}, 0, 'test');

		var interval = setInterval(function(arg1) {
			clearInterval(interval);
			if (arg1 === 'test') {
				// feature test is passed, no need for polyfill
				return;
			}
			var __nativeSI__ = window.setInterval;
			window.setInterval = function(vCallback, nDelay) {
				var aArgs = Array.prototype.slice.call(arguments, 2);
				return __nativeSI__(vCallback instanceof Function ? function() {
					vCallback.apply(null, aArgs);
				} : vCallback, nDelay);
			};
		}, 0, 'test');
	}());

});

